'use strict';
import tasksTemplate from './ngTemplates/asset-project-tasks-list.html';
import activityFeedTemplate from './ngTemplates/asset-project-activity-feed.html';
import timerLogTemplate from './ngTemplates/asset-project-timer-log.html';
import {TaskType} from '../tasks/enums/TaskType';
import {assetTasksStates} from '../tasks/router-config';
import {assetProjectStates} from './router-config';


export const assetProjectCtrlConfig = {
  taskType: TaskType.ASSET,
  modelDomain: 'AssetTaskDomain',
  taskListState: assetProjectStates.tasks,
  taskDetailsState: assetTasksStates.requirements,
};

routerAssetProjectProvider.$inject = [
  '$stateProvider',
];

export function routerAssetProjectProvider($stateProvider) {
  $stateProvider
    .state(assetProjectStates.tasks, {
      title: 'projects.views.tasks.title',
      url: '/tasks',
      views: {
        'tab-assets-tasks': {
          template: tasksTemplate,
          controller: 'TasksListController as tasksList',
        },
      },
      resolve: {
        ctrlConfig: () => Object.assign({
          taskDetailsState: assetTasksStates.requirements,
        }, assetProjectCtrlConfig),
      },
    })

    .state(assetProjectStates.activityFeed, {
      title: 'projects.views.activity.title',
      url: '/activity-feed',
      views: {
        'tab-assets-tasks': {
          template: activityFeedTemplate,
        },
      },
      resolve: {
        ctrlConfig: () => assetProjectCtrlConfig,
      },
    })

    .state(assetProjectStates.timerLog, {
      title: 'projects.views.timer.title',
      url: '/timer-log',
      views: {
        'tab-assets-tasks': {
          template: timerLogTemplate,
        },
      },
      resolve: {
        ctrlConfig: () => assetProjectCtrlConfig,
      },
    });
}



// WEBPACK FOOTER //
// ./src/js/projects/router-asset-project.js